/** @module root/components/administration/settings */

import * as STATES                  from './adm-categorisation.states';

import { admCatCenters }                from './centers/adm-cat-centers.component'
import { admCatCentersGrid }            from './centers/grid/adm-cat-centers-grid.component'
import { admCatCenterDetails }          from './centers/details/adm-cat-center-details.component'
import { admCatCenterModules }         from './centers/details/adm-cat-center-modules.component'

import { admCatDocuments }              from './documents/adm-cat-documents.component'
import { admCatDocumentsGrid }          from './documents/grid/adm-cat-documents-grid.component'
import { admCatDocumentDetails }        from './documents/details/adm-cat-document-details.component'

import { admCatOccupations }            from './occupations/adm-cat-occupations.component'
import { admCatOccupationsGrid }        from './occupations/grid/adm-cat-occupations-grid.component'
import { admCatOccupationDetails }      from './occupations/details/adm-cat-occupatio-details.component'

import { admCatCapabilities }           from './capabilities/adm-cat-capabilities.component'
import { admCatCapabilitiesGrid }       from './capabilities/grid/adm-cat-capabilities-grid.component'
import { admCatCapabilityDetails }      from './capabilities/details/adm-cat-capability-details.component'


export const CATEGORISATION_MODULE = angular.module(
    'migration.administration.categorisation',
    []
).config(['$uiRouterProvider', ({ stateRegistry }) => {
    Object.values(STATES).map(
        state => stateRegistry.register(state)
    );
}]).component({
    admCatCenters,
    admCatCentersGrid,
    admCatCenterDetails,
    admCatCenterModules,

    admCatDocuments,
    admCatDocumentsGrid,
    admCatDocumentDetails,
    
    admCatOccupations,
    admCatOccupationsGrid,
    admCatOccupationDetails,

    admCatCapabilities,
    admCatCapabilitiesGrid,
    admCatCapabilityDetails,

}).run(['$templateCache', ({ put }) => {
    put('app.administration.categorisation.centers.grid',           '<adm-cat-centers></adm-cat-centers>');
    put('app.administration.categorisation.centers.details',        '<adm-cat-center-details></adm-cat-center-details>');
    put('app.administration.categorisation.centers.modules',        '<adm-cat-center-modules></adm-cat-center-modules>');
    
    put('app.administration.categorisation.documents.grid',         '<adm-cat-documents></adm-cat-documents>');
    put('app.administration.categorisation.documents.details',      '<adm-cat-center-details></adm-cat-center-details>');
    
    put('app.administration.categorisation.occupations.grid',       '<adm-cat-occupations></adm-cat-occupations>');
    put('app.administration.categorisation.occupation.details',     '<adm-cat-center-details></adm-cat-center-details>');

    put('app.administration.categorisation.capabilities.grid',       '<adm-cat-capabilities></adm-cat-capabilities>');
    put('app.administration.categorisation.capabilities.details',     '<adm-cat-capability-details></adm-cat-capability-details>');
    
    put('./adm-cat-centers-grid-filter.html',       require('./centers/grid/adm-cat-centers-grid-filter.html'));
    put('./adm-cat-documents-grid-filter.html',     require('./documents/grid/adm-cat-documents-grid-filter.html'));
    put('./adm-cat-occupations-grid-filter.html',   require('./occupations/grid/adm-cat-occupations-grid-filter.html'));
}]);
